import { useState } from "react";
import client from "@/lib/api";
import { toast } from "sonner";
import { Siren, Check, Timer, AlertTriangle } from "lucide-react";

const mins = (iso) => Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));

// Outside-agency assist (BPD / municipal PD / PSP…): request → 20-min arrival timer → ARRIVED. Works on MDT card and incident page.
export const OutsideAssist = ({ incident, agency, phone, compact = false }) => {
  const [busy, setBusy] = useState(false);
  const oa = incident?.outside_assist;
  const req = async () => {
    setBusy(true);
    try { await client.post(`/incidents/${incident.id}/assist-request`, { agency, phone, unit: incident.assigned_units?.[0] || null }); toast.success(`${agency} assist logged — 20-min arrival timer started`); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not log assist"); }
    setBusy(false);
  };
  const arrived = async () => {
    setBusy(true);
    try { const r = await client.post(`/incidents/${incident.id}/assist-arrived`, {}); toast.success(`${oa.agency} arrival noted${r.data.response_min != null ? ` · ${r.data.response_min} min` : ""}`); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not note arrival"); }
    setBusy(false);
  };
  const ack = async () => { try { await client.post(`/incidents/${incident.id}/assist-ack`); toast.success("Lapse acknowledged — re-contact the agency"); } catch { toast.error("Ack failed"); } };
  const btn = compact ? "px-3 py-1.5 rounded font-head font-bold text-xs" : "px-2 py-0.5 font-head font-bold text-[10px]";
  if (!oa && agency) {
    return <button type="button" data-testid="assist-request-btn" disabled={busy} onClick={req} className={`${btn} bg-[#B45309] text-white border border-[#F59E0B] disabled:opacity-50`}><Siren size={11} className="inline mr-1" />{agency.toUpperCase()} ASSIST REQUESTED</button>;
  }
  if (!oa) return null;
  if (oa.arrived_ts) {
    return <span data-testid="assist-arrived-chip" className={`${btn} inline-flex items-center gap-1 bg-[#166534] text-[#BBF7D0] border border-[#22C55E]/60`}><Check size={11} /> {oa.agency.toUpperCase()} ARRIVED · {oa.response_min != null ? `${oa.response_min} min` : (oa.arrived_ts || "").slice(11, 16) + "Z"}</span>;
  }
  return (
    <span data-testid="assist-pending" className="inline-flex flex-wrap items-center gap-1.5">
      <span className={`${btn} inline-flex items-center gap-1 ${oa.lapsed ? "bg-[#7F1D1D] text-[#FECACA] border border-[#EF4444] animate-pulse" : "bg-[#1F2937] text-[#FCD34D] border border-[#F59E0B]/60"}`}>
        {oa.lapsed ? <AlertTriangle size={11} /> : <Timer size={11} />} {oa.agency.toUpperCase()} {oa.lapsed ? `NO ARRIVAL · ${mins(oa.requested_ts)} MIN` : `REQUESTED · ${mins(oa.requested_ts)}/${oa.lapse_min || 20} MIN`}
      </span>
      <button type="button" data-testid="assist-arrived-btn" disabled={busy} onClick={arrived} className={`${btn} bg-[#15803D] text-white border border-[#22C55E] disabled:opacity-50`}><Check size={11} className="inline mr-1" />ARRIVED</button>
      {oa.lapsed && !oa.acknowledged && <button type="button" data-testid="assist-ack-btn" onClick={ack} className={`${btn} border border-[#EF4444] text-[#FCA5A5]`}>ACK</button>}
    </span>
  );
};
